import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const ConciergeKnowledgeSchema = z.object({
  _id: zExt.objectId(),
  teamId: zExt.objectId(),
  whenToUse: z.string(),
  title: z.string(),
  knowledge: z.string(),
  enabled: z.boolean(),
  createdAt: z.date(),
  updatedAt: z.date(),
  expiresAt: z.date().nullish(),
  isSuggestedKnowledge: z.boolean().optional(),
  suggestedKnowledgeInfo: z
    .object({ referencedConversationIds: z.array(z.string()) })
    .optional(),
});
export type ConciergeKnowledge = z.infer<typeof ConciergeKnowledgeSchema>;
